export default __webpack_public_path__ + "static/media/iconGridDos.3d710cd9.png";